import { useContext } from 'react';
import { AppContext } from 'components/context';
import * as moment from 'moment';

export const useAppContextOrThrow = () => {
    const context = useContext(AppContext);
    if (!context)
        throw new Error('Something went wrong when creating context.');
    return context;
};

export const newsSourceMap = (sourceKey: string) => {
    switch (sourceKey) {
        case 'kl':
            return 'Kauppalehti';
        case 'te':
            return 'Talouselämä';
        case 'ap':
            return 'Arvopaperi';
        case 'mm':
            return 'Markkinointi & Mainonta';
        case 'mb':
            return 'Mikrobitti';
        case 'tv':
            return 'Tivi';
        case 'Twitter':
            return sourceKey;
        case 'Facebook':
            return sourceKey;
        case 'monster':
            return 'Monster';
        case 'tepalvelut':
            return 'TE-palvelut';
        default:
            return '';
    }
};

export const cutText = (text: string, startIndex: number) => {
    if (!text) {
        return '';
    }
    if (text.length > startIndex) {
        let i: number = startIndex;
        while (text.charAt(i) !== ' ' && i > 0) {
            i--;
        }
        return `${text.slice(0, i)}...`;
    } else {
        return text;
    }
};

export const isOld = (date?: string): boolean => {
    const now = moment();
    return date !== undefined && moment(date, 'YYYY-MM-DD').isBefore(now);
};
